import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { get_exports } from "./get/index.js";
//#region src/central/v3/user-invites/index.ts
var user_invites_exports = /* @__PURE__ */ __exportAll({ Get: () => get_exports });
//#endregion
export { user_invites_exports };

//# sourceMappingURL=index.js.map